import {
    allowLettersExclusively,
    allowNumbersExclusively,
    email,
    fieldLength,
    fieldMinLength,
    notEmpty,
    required,
    specialCharacters,
    validPhone,
    noSpacesAllowed,
} from '@/modules/shared/shared/domain/rules';

export const contactRules = {
    required,
    fieldLength,
    fieldMinLength,
    email,
    allowNumbersExclusively,
    notEmpty,
    allowLettersExclusively,
    specialCharacters,
    validPhone,
    noSpacesAllowed,
};
